export const APPLICATION_GO_LIVE = new Date('2026-05-11T04:01:00Z'); // 12:01 AM Eastern (EDT, UTC-4)
export const APPLICATION_GO_CLOSE = new Date('2026-06-08T03:59:59Z'); // 11:59:59 PM Eastern on Sunday, June 7, 2026

export function isApplicationLive(now = new Date()) {
    return now >= APPLICATION_GO_LIVE;
}

export function isApplicationClosed(now = new Date()) {
    return now > APPLICATION_GO_CLOSE;
}
